module.exports = __webpack_public_path__ + "fonts/Arimo-500-vietnamese14.32f2d12.woff2";